import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import { Container, Row, Col } from 'react-bootstrap';
import cns from 'classnames';
import releaseImg from 'assets/images/release-img.jpg';
import styles from './press-release.module.scss';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const PRESS_RELEASE_DATA = [
  {
    id: 1,
    title:
      'Dallas selects CAP60 to provide data management services for their new CSBG entity',
    date: 'September 15, 2018',
    link: '/press-release/dallas-selects-cap60-to-provide-data-management-services-for-their-new-csbg-entity',
  },
  {
    id: 2,
    title: 'CAP60 Selected by The State of Wyoming for Data Management Needs',
    date: 'September 15, 2018',
    link: '/press-release/cap60-selected-by-the-state-of-wyoming-for-data-management-needs',
  },
  {
    id: 3,
    title: 'North Dakota Selects CAP60 for Data Management Needs',
    date: 'September 15, 2018',
    link: '/press-release/north-dakota-selects-cap60-for-data-management-needs',
  },
  {
    id: 4,
    title:
      'The Community Action Partnership of Utah Selects CAP60 for Data Management Needs',
    date: 'September 15, 2018',
    link: '/press-release/the-community-action-partnership-of-utah-selects-cap60-for-data-management-need',
  },
];
function PressRelease() {
  return (
    <div>
      <Helmet>
        <title>Press Releases - CAP60</title>
        <meta
          name="description"
          content="Press release is a tool made to announce something that is newsworthy in the most objective way possible. Read all press release for getting more information!."
        />
        <meta name="keywords" content="press release, cap60 press release" />
      </Helmet>
      <PageBanner
        title="Press Releases"
        subtitle="Sign up & stay tuned for our coverage and stay up-to-date on the latest news and product updates from CAP60."
      />
      <Container className="mt-5 mb-4">
        <Row>
          <Col md={7}>
            <img src={releaseImg} className={styles.releaseImg} alt="Release" />
          </Col>
          <Col md={5}>
            {PRESS_RELEASE_DATA.map((item) => (
              <section className={styles.releaseWrap}>
                <div className={cns('', styles.releaseItem)}>
                  <div>
                    <div className="textLight mb-2">
                      <span>{item.date}</span>
                    </div>
                    <Link to={item.link}>
                      {' '}
                      <h4 className="font-s1">{item.title}</h4>
                    </Link>
                  </div>
                </div>
                {/* <hr className="my-2" /> */}
              </section>
            ))}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PressRelease;
